var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-scroll',{staticClass:"page-dashboard"},[_c('el-row',{staticClass:"mt-0",attrs:{"gutter":30}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":12,"lg":6,"xl":6}},[_vm._v(" Dashboard ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }